// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout[data-v-9ec291f2]{display:flex;flex-direction:column;min-height:100vh;padding-top:64px}.layout__main[data-v-9ec291f2]{flex:1;display:flex;flex-direction:column}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
